module.exports = __webpack_public_path__ + "static/media/pg_dnm_high_tide.878f90f4.jpg";